import React, { useEffect } from 'react';
import { MerchantLayout } from '../../../components/merchants/MerchantPage/MerchantLayout';
import { useNavigate, useParams } from 'react-router-dom';
import { PageTitle } from '../../../layout/core';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { MERCHANTS_TABS } from '../../../utils/merchantUtils';
import { useMerchants } from '../../../store/merchnts/merchants-context';
import { fetchMerchantData, setMerchantDetailsDataDefault, setStatus } from '../../../store/merchnts/actions/merchant';
import { fetchFees } from '../../../store/merchnts/actions/fees';
import { IAuthState } from '../../../redux/AuthRedux';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../../setup';
import { checkRoles, CLAIMS } from '../../../utils/roles-helper';

import './MerchantPage.scss';

export const MerchantPage = (props: { children: React.ReactElement }): JSX.Element => {
	const { t } = useTranslation();
	const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);
	const { state, pathname } = useLocation();
	const navigate = useNavigate();
	const { id } = useParams<{ id: string }>();
	const merchantId = id;
	const { merchantState: { merchantData, standardFees, merchantFee }, dispatch } = useMerchants();
	const backUrl = (): string => {
		let baseBackUrl = '/accounts/merchants';
		if (state) {
			baseBackUrl += state?.search || '';
		}
		const returnPages = [MERCHANTS_TABS.CHECKOUT_CONFIGURATIONS, MERCHANTS_TABS.WIDGET_CONFIGURATIONS, MERCHANTS_TABS.SENSE_JS, MERCHANTS_TABS.FEES_HISTORY, MERCHANTS_TABS.WEBHOOKS];
		const res = returnPages?.find(el => pathname?.includes(el));

		if (res) {
			switch (res) {
				case MERCHANTS_TABS.CHECKOUT_CONFIGURATIONS: return `/accounts/merchants/${merchantId}/${MERCHANTS_TABS.SITES}`;
				case MERCHANTS_TABS.WIDGET_CONFIGURATIONS: return `/accounts/merchants/${merchantId}/${MERCHANTS_TABS.SITES}`;
				case MERCHANTS_TABS.SENSE_JS: return `/accounts/merchants/${merchantId}/${MERCHANTS_TABS.SITES}`;
				case MERCHANTS_TABS.FEES_HISTORY: return `/accounts/merchants/${merchantId}/${MERCHANTS_TABS.FEES}`;
				case MERCHANTS_TABS.WEBHOOKS: {
					const splitPathname = pathname.split('/');
					const lastTag = splitPathname[splitPathname.length - 1];
					if (lastTag === MERCHANTS_TABS.WEBHOOKS) {
						return baseBackUrl;
					} else {
						return `/accounts/merchants/${merchantId}/${MERCHANTS_TABS.WEBHOOKS}`;
					}
				}
				default: return`/${res}`;
			}
		}

		return baseBackUrl;
	};

	useEffect(() => {
		if (pathname === `/accounts/merchants/${merchantId}`) {
			navigate(`/accounts/merchants/${merchantId}/${MERCHANTS_TABS.BUSINESS}`);
		}
	}, []);

	useEffect(() => {
		void fetchMerchantData(dispatch, id);
	}, [id]);

	useEffect(() => {
		if (checkRoles(authUser, CLAIMS.SUPER_ADMIN_AND_ONLY_PARTNER_ADMIN)) {
			void fetchFees(dispatch, standardFees, merchantFee);
		}
	}, []);

	useEffect(() => {
		return () => {
			setMerchantDetailsDataDefault(dispatch);
		};
	}, []);

	return (
		<>
			<PageTitle
				breadcrumbs={[
					{
						title: t('MENU.ACCOUNTS'),
						path: '/accounts/accounts',
						isSeparator: false,
						isActive: false
					},
					{
						title: '',
						path: '',
						isSeparator: true,
						isActive: false
					}
				]}
			>
				{merchantId}
			</PageTitle>
			<MerchantLayout
				activate={async (): Promise<void> => await setStatus(dispatch, merchantId, merchantData)}
				backUrl={backUrl()}
			>
				{props.children}
			</MerchantLayout>
		</>
	);
};
